import React from "react";
import Alert from "@material-ui/lab/Alert";

const VoucherEmpty = ({ title, message, divider }) => {
  return (
    <div className={divider ? "lp-voucher-section mt-4" : ""} style={!divider ? { marginTop: "1rem" } : undefined}>
      {title && (
        <p className="lp-voucher-section__title">{title}</p>
      )}
      <Alert severity="info">
        {message || "Nenhum voucher Pacto disponível para este produto."}
      </Alert>
    </div>
  );
};

export default VoucherEmpty;
